import { useDispatch } from 'react-redux';
import type { AppDispatch } from '../infrastructure/Store';

export function useAppDispatch() {
  return useDispatch<AppDispatch>();
}
